import { RESET_DATA } from '../actions/application';
import {
  FETCH_APPLICATION_BUILD_PACKAGE_STATE_LOADING,
  FETCH_APPLICATION_BUILD_PACKAGE_STATE_SUCCESS_FORMAL,
  FETCH_APPLICATION_BUILD_PACKAGE_STATE_FAILED,
} from "../actions/applicationBuild";
import {
  SET_CHECK_MODAL_VISIBLE,
  SET_VERSION_MODAL_VISIBLE,
  SET_PAGEVIEW,
  FETCH_APPLICATION_ANDROID_CHECK_SUCCESS,
} from "../actions/applicationGuide"

const defVal = {
  buildPackageState: 0, // 正式包构建状态 0 未构建 1 构建中 2 构建完成 3 构建失败
  innerAndroidDownloadUrl: "", // 国内Android下载地址
  outterAndroidDownloadUrl: "", // 海外Android下载地址
  iosDownloadUrl: "", // IOS下载地址
  // 是否显示检验弹窗
  guideCheckModalVisible: false,
  // 输入版本弹窗
  versionModalVisible: false,
  // 正式打包前校验信息
  changeInfo: {},
  pageView: 0, // 页面展示 0 证书配置 1 构建结果
};

export default (state = defVal, action) => {
  switch (action.type) {
    case FETCH_APPLICATION_BUILD_PACKAGE_STATE_SUCCESS_FORMAL:
      console.log(`action.buildPackageState => ${action.buildPackageState}`)
      return Object.assign({}, state, {
        buildPackageState: action.buildPackageState,
        innerAndroidDownloadUrl: action.innerAndroidDownloadUrl,
        outterAndroidDownloadUrl: action.outterAndroidDownloadUrl,
        iosDownloadUrl: action.iosDownloadUrl,
      });
    case SET_CHECK_MODAL_VISIBLE:
      return Object.assign({}, state, {
        guideCheckModalVisible: action.guideCheckModalVisible,
      });
    case SET_VERSION_MODAL_VISIBLE:
      return Object.assign({}, state, {
        versionModalVisible: action.versionModalVisible,
      });
    case SET_PAGEVIEW:
      return Object.assign({}, state, {
        pageView: action.pageView,
      });
    case FETCH_APPLICATION_ANDROID_CHECK_SUCCESS:
      return Object.assign({}, state, {
        changeInfo: action.changeInfo,
      });

    case RESET_DATA:
      return Object.assign({}, state, {
        buildPackageState: 0, // 正式包构建状态 0 未构建 1 构建中 2 构建完成 3 构建失败
        innerAndroidDownloadUrl: "", // 国内Android下载地址
        outterAndroidDownloadUrl: "", // 海外Android下载地址
        iosDownloadUrl: "", // IOS下载地址
        // 是否显示检验弹窗
        guideCheckModalVisible: false,
        // 输入版本弹窗
        versionModalVisible: false,
        // 正式打包前校验信息
        changeInfo: {},
        pageView: 0, // 页面展示 0 证书配置 1 构建结果
      });

    default:
      return state;
  }
};
